import { Routes, Route, Navigate } from "react-router-dom";
import PublicLayout from "@/components/layout/PublicLayout";
import AppLayout from "@/components/layout/AppLayout";
import AuthGuard from "@/components/AuthGuard";
import Landing from "@/routes/Landing";
import Signup from "@/routes/Signup";
import Login from "@/routes/Login";
import Dashboard from "@/routes/Dashboard";
import Profile from "@/routes/Profile";
import CompaniesList from "@/routes/CompaniesList";
import CompanyNew from "@/routes/CompanyNew";
import CompanyOverview from "@/routes/CompanyOverview";
import Integrations from "@/routes/Integrations";
import Tasks from "@/routes/Tasks";
import Calculators from "@/routes/Calculators";
import Partners from "@/routes/Partners";
import Settings from "@/routes/Settings";
import FreeAgentCallback from "@/routes/FreeAgentCallback";
import SharedReport from "@/routes/SharedReport";

export default function App() {
  return (
    <Routes>
      {/* Public — server-rendered SEO landings live on these paths via the
          Worker in prod; this is the dev/fallback render. */}
      <Route element={<PublicLayout />}>
        <Route path="/dashboard" element={<Landing />} />
        <Route path="/dashboard/login" element={<Login />} />
        <Route path="/dashboard/signup" element={<Signup />} />
      </Route>

      {/* OAuth callback — no chrome, just transit */}
      <Route path="/auth/freeagent/callback" element={<FreeAgentCallback />} />

      {/* Public shared report — token-gated, branded from snapshot */}
      <Route path="/r/:token" element={<SharedReport />} />

      {/* Authenticated dashboard */}
      <Route
        element={
          <AuthGuard>
            <AppLayout />
          </AuthGuard>
        }
      >
        <Route path="/dashboard/app" element={<Dashboard />} />
        <Route path="/dashboard/app/profile" element={<Profile />} />
        <Route path="/dashboard/app/company" element={<CompaniesList />} />
        <Route path="/dashboard/app/companies" element={<CompaniesList />} />
        <Route path="/dashboard/app/companies/new" element={<CompanyNew />} />
        <Route
          path="/dashboard/app/companies/:companyId"
          element={<CompanyOverview />}
        />
        <Route path="/dashboard/app/integrations" element={<Integrations />} />
        <Route path="/dashboard/app/tasks" element={<Tasks />} />
        <Route path="/dashboard/app/calculators" element={<Calculators />} />
        <Route path="/dashboard/app/partners" element={<Partners />} />
        <Route path="/dashboard/app/settings" element={<Settings />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
